<template>
  <v-container class="billing">
    <v-row>
      <v-col cols="12">
        <WarningAlert>
          {{ $t('billing.title') }}
          <br>
          {{ $t('billing.title_1') }}
        </WarningAlert>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
            :headers="billingHeaders"
            :items="billingItems"
            class="elevation-4" 
            hide-default-header
            :mobile-breakpoint="0"
            :footer-props="{
              'items-per-page-text': $t('dataTable.rowsPerPageText'),
              'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
            }"
            :no-data-text="$t('dataTable.noDataText')"
            :headerProps="{
              'sort-by-text': $t('dataTable.sortByText')
            }"
        >
            <template v-slot:header="{ props: { headers } }">
                <thead>
                    <tr>
                        <th v-for="(h, i) in headers" :key="i">{{ h.text }}</th>
                    </tr>
                </thead>
            </template>
            <template v-slot:item="props">
                <tr>
                    <td v-if="props.item.memberId > 0">{{ $t("billing.membership") }}</td>
                    <td v-else>{{ $t("billing.event") }}</td>
                    <td>${{ props.item.grossAmount }}</td>
                    <td>{{ props.item.purchaseCreated | formatDateForHumans }}</td>
                    <td>{{ props.item.responseId}}</td>
                    <td>{{ props.item.paypalSaleId }}</td>
                    <td>{{ props.item.paypalInvoiceNumber}}</td>
                </tr>
            </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BillingService from "../services/BillingService";
import { VContainer, VRow, VCol, VDataTable } from 'vuetify/lib';
import WarningAlert from '@/components/alert/WarningAlert.vue';

export default {
  name: "Billing",
  components: { VContainer, VRow, VCol, VDataTable, WarningAlert },
  data() {
    return {
      buttonColor: "#000",     
      billingItems: []
    };
  },
  created(){
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    this.itemsBilling_();
  },
  mounted() {
    this.$emit("titlePage", "billing.title");
    this.$emit("dynamicMenuItems", this.dynamicMenuItems);    
  },
  computed: {
    billingHeaders(){
      return [
        {
          text: this.$t("billing.purchase_type"),
          align: "",
          sortable: false,
          value: "fName"
        },
        { text: this.$t("billing.amount"), value: "grossAmount" },
        { text: this.$t("billing.timestamps"), value: "purchaseCreated" },
        { text: this.$t("billing.charge_id"), value: "responseId" },
        { text: this.$t("billing.paypalSaleId"), value: "paypalSaleId" },
        { text: this.$t("billing.paypalInvoiceNumber"), value: "paypalInvoiceNumber" }
      ]
    }
  },
  watch: {},
  methods: {
    itemsBilling_(){
      BillingService.getPaymentList().then(response => {
        if(response.data.success == 1){
          this.billingItems = response.data.message;
        }
      });
    }
  }
};
</script>

<style scoped>
.billing .v-data-table-header,
.billing .v-card__title {
  background: #ccc;
}
.table-container {
  width: 100%;
  overflow-x: auto;
}
.v-data-table {
  width: 100%;
  margin: 20px 0;
}
.mt16 {
  margin-top: 16px;
}
.btn{
  color:#fff !important;
}
</style>